<template>
  <label
    class="variation"
    :class="{'disabled': disabled}"
    :for="`variation-${index}`"
    :title="title"
  >
    <input type="radio"
      name="variation"
      :id="`variation-${index}`"
      :checked="selected"
      :disabled="disabled"
    >
    <div>
      <div class="thumb">
        <img
          :src="thumbnail"
          :alt="title">
      </div>
      <div class="title text-tiny">
        {{ title }}
      </div>
      <svg
        v-if="disabled"
        class="not"
        fill="currentColor"
        width="14"
        height="14"
        viewBox="0 0 24 24"
      >
        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm9 12c0 1.94-.624 3.735-1.672 5.207l-12.535-12.535c1.472-1.048 3.267-1.672 5.207-1.672 4.962 0 9 4.038 9 9zm-18 0c0-1.94.624-3.735 1.672-5.207l12.534 12.534c-1.471 1.049-3.266 1.673-5.206 1.673-4.962 0-9-4.038-9-9z"/>
      </svg>
    </div>
  </label>
</template>

<script>
import { ucfirst } from '../helpers.js';

export default {
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    index: {
      default: 0,
      type: Number,
    },
    item: {
      required: true,
      type: Object,
    },
    selected: {
      default: false,
      type: Boolean,
    },
  },

  computed: {
    reason() {
      let msg = '';

      if(!this.disabled) {
        return;
      }

      msg += (this.item.comingsoon === 1) ? 'coming soon' : 'back-ordered';

      if(this.item.expectedDate) {
        msg += ', available on ' + new Date(this.item.expectedDate + ' CST')
                                    .toLocaleDateString('en-US');
      }

      return msg;
    },

    thumbnail() {
      return this.$root.imageDomain + this.item.sku + '-F.jpg';
    },

    title() {
      return ucfirst(this.item.variation_title || this.item.title);
    }
  }
}
</script>

<style scoped>
.variation {
  cursor: pointer;
  font-weight: normal;
  padding: 5px;
  position: relative;
}

.variation > input {
  position: absolute;
  opacity: 0;
}

.variation > div {
  background-color: #FFF;
  border: 1px solid #CCC;
  border-radius: .25em;
  color: #5F5F5F;
  padding: .5em;
  position: relative;
  width: 80px;
}

.variation:not(.disabled) > div:hover,
.variation:not(.disabled) > input:checked + div {
  border-color: #909090;
  color: #181e27;
}

.variation:not(.disabled) > div:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.35);
}

.variation:not(.disabled) > input:checked + div {
  box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.35);
}

.variation:not(.disabled) > input:focus + div {
  border-color: #00549d;
  box-shadow: inset 0 0.2em 0.5em rgba(0,0,0,.09),
              0 0 0.5em 0.1em rgba(0,84,157,.75);
}

.variation.disabled {
  cursor: not-allowed;
}

.variation.disabled > div {
  border-style: dashed;
  color: #A9A9A9;
}

.variation.disabled .thumb {
  opacity: .25;
}

.title {
  margin-top: .25em;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.thumb {
  border-radius: .25em;
  overflow: hidden;
  position: relative;
  width: 100%;
  aspect-ratio: 1;
}

.thumb > img {
  display: block;
  height: auto;
  max-width: 100%;
  width: 100%;
}

.not {
  position: absolute;
  right: 3px;
  top: 3px;
}
</style>
